import '../styles/mobilemenutoggle.scss';

import { h, Component } from 'preact';

export default function mobilemenutoggle (props) {

  return <div class="hamburgher menuItemCheck" onClick={ props.cb }>
    <span></span>
    <span></span>
    <span></span>
  </div>;

};


// WEBPACK FOOTER //
// ./ts/mobilemenutoggle.tsx